'use client'

import { journeysPassFooterView } from '@/features/passes'
import { useUserProgress } from '@/shared/contexts/UserProgress'
import { useGamificationData } from '@/shared/hooks/useGamificationData'
import { AppLink } from '@/shared/lib/router'
import { Button } from '@/shared/ui/Button'

export function JourneysPassFooter() {
  // Construído só a partir do gamification: definições (Data.passes) + estado
  // por objetivo e campanhas (/gamification/progress). Não chama /user/passes.
  const data = useGamificationData()
  const { passObjectiveProgresses, campaignIds } = useUserProgress()

  const view = journeysPassFooterView(
    data?.passes ?? [],
    campaignIds,
    passObjectiveProgresses
  )
  if (!view) return null

  return (
    <div className="bg-primary-dark text-white px-4 py-4 flex items-center justify-between gap-4 rounded-t-2xl lg:rounded-2xl shadow-lg">
      <div className="min-w-0">
        <p className="font-bold">{view.title}</p>
        <div className="w-40 lg:w-48 h-2 rounded-full bg-white/20 mt-1">
          <div
            className="h-full rounded-full bg-brand-yellow transition-[width] duration-300"
            style={{ width: `${view.progress}%` }}
          />
        </div>
        {view.nextReward ? (
          <p className="text-sm text-white/80 mt-1 truncate">
            Próxima recompensa: {view.nextReward}
          </p>
        ) : null}
      </div>
      <Button asChild variant="primary" size="sm" className="shrink-0">
        <AppLink href="/passe">Ver passe</AppLink>
      </Button>
    </div>
  )
}
